import { mapGetters } from 'vuex'
import i18n from '@/i18n'
import { ColvenTheme } from '@/constants/constants'
import { clone } from 'ramda'
import AutocompleteComponent from "@/components/commons/autocomplete/AutocompleteComponent.vue";

export default {
    name: 'EnterpriseThemeTabComponent',
    components: {
        AutocompleteComponent
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules:{
            type: Object,
            required: true
        },
        validForm:{
            type: Boolean,
            required: true
        },
        resetFormValidation:{
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        isValidForm: false,
        // modo dark
        dark: false,
        // componentes por defecto de los temas, se pueden agregar y utilizar más
        themeComponents: [
            {
                id: 'primary',
                name: i18n.t('enterprise.editDialog.themes.primary')
            },
            {
                id: 'secondary',
                name: i18n.t('enterprise.editDialog.themes.secondary')
            },
            {
                id: 'icon-primary',
                name: i18n.t('enterprise.editDialog.themes.iconPrimary')
            },
            {
                id: 'icon-secondary',
                name: i18n.t('enterprise.editDialog.themes.iconSecondary')
            },
            {
                id: 'accent',
                name: i18n.t('enterprise.editDialog.themes.accent')
            },
            {
                id: 'error',
                name: i18n.t('enterprise.editDialog.themes.error')
            },
            {
                id: 'success',
                name: i18n.t('enterprise.editDialog.themes.success')
            },
            {
                id: 'info',
                name: i18n.t('enterprise.editDialog.themes.info')
            },
            {
                id: 'warning',
                name: i18n.t('enterprise.editDialog.themes.warning')
            }
        ],
        // componente de tema seleccionado
        selectedThemeComponent: 'primary'
    }),
    computed: {
        /**
         * ícono dark/light
         */
        themeIcon () {
            if (this.dark) {
                return 'wb_sunny'
            } else {
                return 'brightness_2'
            }
        },
        /**
         * getter del username
         */
        ...mapGetters('user', [
            'getUsername'
        ])
    },
    created () {
        // verificación por si la empresa no tiene configurado temas
        if (this.model.update) {
            if (!this.model.themes) {
                this.model.themes = clone(ColvenTheme)
            } else {
                if (!this.model.themes.light) {
                    this.model.themes.light = clone(ColvenTheme.light)
                }
                if (!this.model.themes.dark) {
                    this.model.themes.dark = clone(ColvenTheme.dark)
                }
            }
        }
    },
    mounted () {
    },
    methods: {
        /**
         * Cada vez que se modifica la selección del tema, se cargan
         */
        themeSelectedFunction (newValue) {
            this.selectedThemeComponent = newValue.id ? newValue.id : newValue;
        },
    },
    watch: {
        /**
         * Para validar el formulario
         * @param {*} newVal
         * @param {*} oldVal
         */
        isValidForm(newVal, oldVal){
            if(newVal!==oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.enterpriseThemeForm) {
                this.$refs.enterpriseThemeForm.resetValidation()
            }
        }
    }
}
